import { render, staticRenderFns } from "./MobileSolveIndex.vue?vue&type=template&id=1c3ad9ca&scoped=true&"
import script from "./MobileSolveIndex.vue?vue&type=script&lang=js&"
export * from "./MobileSolveIndex.vue?vue&type=script&lang=js&"
import style0 from "./MobileSolveIndex.vue?vue&type=style&index=0&id=1c3ad9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ad9ca",
  null
  
)

export default component.exports